module.exports = __webpack_public_path__ + "static/media/respodent_volume@3x.977ddb36.png";